import * as React from 'react';
import Modal from '@mui/material/Modal';
import styled from '@emotion/styled';
import theme from '../../commons/theme';

const ErrorInfo = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    transform: translate(-50%, -50%);
    width: 453px;
    height: 244px;
    border-radius: 4px;
    background-color: white;
    text-align: center;

    h1 {
        color: ${theme.warning};
        font-family: ${theme.subTitle};
        font-size: 2.2rem;
    }

    pre {
        color: ${theme.grey_800};
        font-family: ${theme.text};
        font-size: 1.8rem;
    }

    @media all and (max-width: 768px) {
        width: 327px;

        h1 {
            font-size: 1.8rem;
        }

        pre {
            font-size: 1.6rem;
        }
    }
`;

const Button = styled.button`
    width: 164px;
    height: 48px;
    border: none;
    border-radius: 100px;
    border: 1px solid ${theme.warning};
    background-color: white;
    color: ${theme.warning};
    font-family: ${theme.subTitle};
    font-size: 1.8rem;

    :hover {
        cursor: pointer;
    }

    @media all and (max-width: 768px) {
        width: 248px;
        font-size: 1.6rem;
    }
`;

function ErrorModal({ open, handleClose }) {
    return (
        <Modal open={open} onClose={handleClose}>
            <ErrorInfo>
                <h1>안내</h1>
                <pre>{`보내기 실패했습니다.\n잠시 후 다시 시도해주시기 바랍니다.`}</pre>
                <Button onClick={handleClose}>확인</Button>
            </ErrorInfo>
        </Modal>
    );
}

export default ErrorModal;
